// Firebase v8 SDK — compatible with CRA v3 / react-scripts 3.x
import firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCQYAvc-dAaLBTlo__IaxjXKMmN7Ghr6oo",
  authDomain: "darista-shop.firebaseapp.com",
  projectId: "darista-shop",
  storageBucket: "darista-shop.firebasestorage.app",
  messagingSenderId: "735285650600",
  appId: "1:735285650600:web:a22ec367adff11844e4e9d",
  measurementId: "G-B34CWS0S6G",
};

const VAPID_KEY = "BNMcuRk36ZKvOmoU1PQQLRFCglSAde6ZI_docCSUZoKfAndZXTPfqI6pChlU61ixZUuqVmExTVv6ve1t74AUvxw";

// Initialize Firebase (only once)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

let _messaging = null;
let _configured = false;

/**
 * Get Firebase Messaging instance.
 * Returns null if the browser doesn't support notifications.
 */
export const getFirebaseMessaging = () => {
  if (_messaging) return _messaging;
  try {
    if ('Notification' in window && 'serviceWorker' in navigator) {
      _messaging = firebase.messaging();
      // Set VAPID key once (v8 API)
      _messaging.usePublicVapidKey(VAPID_KEY);
      return _messaging;
    }
  } catch (err) {
    console.error('Firebase Messaging not supported:', err);
  }
  return null;
};

/**
 * Request notification permission and get the FCM token.
 * Returns the token string or null if denied.
 */
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    const msg = getFirebaseMessaging();
    if (!msg) return null;

    // Wait for our service worker to be ready
    const registration = await navigator.serviceWorker.ready;

    // Bind messaging to our service worker (v8 API, call once)
    if (!_configured) {
      msg.useServiceWorker(registration);
      _configured = true;
    }

    // v8 getToken() takes no arguments — VAPID key set via usePublicVapidKey
    const token = await msg.getToken();

    console.log('FCM Token:', token);
    return token;
  } catch (err) {
    console.error('Error getting FCM token:', err);
    return null;
  }
};

/**
 * Listen for foreground messages.
 * @param {function} callback - Called with { title, body, data }
 */
export const onForegroundMessage = (callback) => {
  const msg = getFirebaseMessaging();
  if (!msg) return () => {};

  const unsubscribe = msg.onMessage((payload) => {
    console.log('Foreground message:', payload);
    const { title, body } = (payload.notification) || {};
    const data = payload.data || {};
    callback({ title, body, data });
  });

  return unsubscribe;
};

export default firebase;
